export const PATTERN = "000.000.000/000-00";
